module.exports = __webpack_public_path__ + "313cef742a95de950de31c8ecb868cd3.png";